import * as _ from 'lodash';
import { SORT_VIEW } from 'Common/enums';
import useCubeReportQuery from './useCubeReportQuery';

function useRulePerformance(
    chartType: RulePerformanceChartType,
    sortType: SortType,
    formValues?: ProcessedPerformanceReportFormValues
) {
    const query: any = formValues?.fullQueries?.[`${chartType}RuleQuery`];
    const { resultSet, isLoading } = useCubeReportQuery(formValues, query);
    const capitalizedChartType = _.capitalize(chartType);
    const pivotData = resultSet?.tablePivot();
    let processedData: RulePerformanceTableItem[] = [];
    let totalTransactions = 0;
    if (pivotData && pivotData.length) {
        totalTransactions = pivotData.reduce(function philsFunction(acc, obj: any) {
            return acc + Number(obj['Performance.matches']);
        }, 0);
        const topPercentage =
            Number(pivotData[0]['Performance.matches']) > 0
                ? Number(pivotData[0]['Performance.matches']) / totalTransactions
                : 0;
        if (sortType === SORT_VIEW.HIGH) {
            pivotData.sort((a: any, b: any) => Number(b['Performance.matches']) - Number(a['Performance.matches']));
        } else if (sortType === SORT_VIEW.LOW) {
            pivotData.sort((a: any, b: any) => Number(a['Performance.matches']) - Number(b['Performance.matches']));
        } else {
            // Alphanumerical
            pivotData.sort((a: any, b: any) =>
                a['Performance.rule'].localeCompare(b['Performance.rule'], { numeric: true })
            );
        }
        processedData = pivotData.map((pData: Record<string, any>) => {
            const matchPercent =
                Number(pData['Performance.matches']) > 0
                    ? +Number(pData['Performance.matches']) / totalTransactions
                    : 0;
            return {
                merchantId: pData['Performance.mid'],
                rule: pData['Performance.rule'],
                matches: pData['Performance.matches'],
                [chartType]: 0,
                [`percentScaledTriggered${capitalizedChartType}`]:
                    topPercentage !== 0 ? (matchPercent * 100) / topPercentage : 0,
                [`percentTriggered${capitalizedChartType}`]: matchPercent * 100
            };
        });
    }

    return {
        isLoading,
        processedData,
        totalTransactions
    };
}

export default useRulePerformance;
